module.exports = __webpack_public_path__ + "img/Terrain_Digging_Simulator-2.f9dd0a44.png";